// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "ProfilePage" + "." + "465c4e7c" + ".chunk.css";
};